import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { CMSDataControllerService } from "@app/core/data/controller/cmsdata-controller.service";
import DailyIframe, { DailyCall, DailyParticipant } from "@daily-co/daily-js";
import { environment } from "@env/environment";
import { ModalController } from "@ionic/angular";
import { LoadingService } from "../services/loading.service";

@Component({
  selector: "app-ia-avatar",
  templateUrl: "./ia-avatar.component.html",
  styleUrls: ["./ia-avatar.component.scss"],
})
export class IaAvatarComponent implements OnInit {
  private callFrame: DailyCall | null = null;
  private mySessionId: string | null = null;
  public session: any;
  tavusCall: any;
  conversation: any;
  isInCall: boolean;
  loading: boolean;
  constructor(
    public cmsdataController: CMSDataControllerService,
    public modalController: ModalController,
    public loadingService: LoadingService,
    private http: HttpClient
  ) {}

  async ngOnInit() {
    this.tavusCall = {
      replica_id: environment.tavus.replica_id,
      persona_id: environment.tavus.persona_id,
      callback_url: environment.tavus.callback_url,
      conversation_name: "TrueOmni Test Call",
      conversational_context:
        "You are a warm and friendly agent who works for trueomni in Guadalajara at TrueOmni...",
      custom_greeting:
        "Hello and welcome to TrueOmni, what can I do for you today?",
      properties: {
        max_call_duration: 3600,
        participant_left_timeout: 60,
        participant_absent_timeout: 30,
        enable_recording: false,
        enable_transcription: false,
        apply_greenscreen: false,
        language: "english",
        recording_s3_bucket_name: "",
        recording_s3_bucket_region: "",
        aws_assume_role_arn: "",
      },
    };
  }

  async joinCall() {
    await this.loadingService.presentLoading();
    this.cmsdataController.initCall(this.tavusCall).then((resp) => {
      this.conversation = resp;
      this.isInCall = true;
      const container = document.getElementById("iframe-container");
      if (!container) return;
      this.callFrame = DailyIframe.createFrame(container, {
        showLeaveButton: true,
        iframeStyle: {
          height: "80vh",
          width: "100%",
          border: "0",
        },
      });
      this.callFrame.join({
        url: this.conversation.conversation_url,
      });
      this.loadingService.dismiss();
    });
  }

  async leaveCall() {
    if (this.isInCall && this.conversation) {
      this.cmsdataController
        .leaveCall(this.tavusCall, this.conversation.conversation_id)
        .then((resp) => {
          this.isInCall = false;
          this.callFrame.leave();
          this.callFrame.destroy();
          this.callFrame = null;
        });
    }
  }

  close() {
    this.leaveCall();
    this.modalController.dismiss();
  }
}
